
  export default {
    mounted() { this.maybeStartTimer() },
    updated() { clearTimeout(this.timer); this.maybeStartTimer() },
    destroyed() { clearTimeout(this.timer) },
    maybeStartTimer() {
      if (this.el.dataset.autoDismiss !== "false") {
        this.timer = setTimeout(() => this.el.click(), 5000)
      }
    }
  }
